/** 主图上传（侧栏「加载图片」/ 画布「点击加载图片」）禁止 GIF */

export function isGifFile(file: File): boolean {
  const t = (file.type || '').toLowerCase();
  if (t === 'image/gif') return true;
  const n = (file.name || '').toLowerCase();
  return n.endsWith('.gif');
}
